import { useEffect, useRef } from 'react';

export default function ProductsCTA() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-up');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const els = sectionRef.current?.querySelectorAll('.reveal');
    els?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative bg-[#1A1A1A] py-20 md:py-28 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, #D4A853 1px, transparent 0)',
          backgroundSize: '40px 40px',
        }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        <div className="reveal opacity-0 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left Content */}
          <div>
            <span className="inline-block text-xs font-semibold tracking-widest uppercase text-[#D4A853] mb-4">
              კონსულტაცია
            </span>
            <h2 className="font-serif text-3xl md:text-5xl font-bold text-white mb-6 leading-tight">
              ვერ იპოვეთ სასურველი
              <span className="text-[#D4A853]"> პროდუქტი?</span>
            </h2>
            <p className="text-white/60 text-base md:text-lg leading-relaxed mb-8">
              ჩვენი გუნდი დაგეხმარებათ სწორი მასალების შერჩევაში. მიუხედავად პროექტის მასშტაბისა, 
              ჩვენ გთავაზობთ ინდივიდუალურ მიდგომას და საუკეთესო ფასებს ბაზარზე.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:+995599872020"
                className="inline-flex items-center justify-center gap-2 bg-[#D4A853] text-[#1A1A1A] font-semibold px-8 py-4 rounded-lg hover:bg-[#C49A4A] transition-colors duration-300 whitespace-nowrap"
              >
                <i className="ri-phone-line"></i>
                +995 599 87 20 20
              </a>
              <a
                href="mailto:info@phoenix.ge"
                className="inline-flex items-center justify-center gap-2 border border-white/20 text-white font-semibold px-8 py-4 rounded-lg hover:bg-white/10 transition-colors duration-300 whitespace-nowrap"
              >
                <i className="ri-mail-line"></i>
                info@phoenix.ge
              </a>
            </div>
          </div>

          {/* Right - Contact Info Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="bg-[#252525] rounded-xl p-6 border border-white/5">
              <div className="w-10 h-10 rounded-full bg-[#D4A853]/20 flex items-center justify-center mb-4">
                <i className="ri-map-pin-line text-[#D4A853]"></i>
              </div>
              <h3 className="font-semibold text-white mb-2">მისამართი</h3>
              <p className="text-sm text-white/50">გელოვანის ქ. N13, თბილისი, საქართველო</p>
            </div>

            <div className="bg-[#252525] rounded-xl p-6 border border-white/5">
              <div className="w-10 h-10 rounded-full bg-[#D4A853]/20 flex items-center justify-center mb-4">
                <i className="ri-time-line text-[#D4A853]"></i>
              </div>
              <h3 className="font-semibold text-white mb-2">სამუშაო საათები</h3>
              <p className="text-sm text-white/50">ორშ - შაბ: 09:30 - 19:30</p>
            </div>

            <div className="bg-[#252525] rounded-xl p-6 border border-white/5">
              <div className="w-10 h-10 rounded-full bg-[#D4A853]/20 flex items-center justify-center mb-4">
                <i className="ri-truck-line text-[#D4A853]"></i>
              </div>
              <h3 className="font-semibold text-white mb-2">მიწოდება</h3>
              <p className="text-sm text-white/50">თბილისში და რეგიონებში</p>
            </div>

            <div className="bg-[#252525] rounded-xl p-6 border border-white/5">
              <div className="w-10 h-10 rounded-full bg-[#D4A853]/20 flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-[#D4A853]"></i>
              </div>
              <h3 className="font-semibold text-white mb-2">გარანტია</h3>
              <p className="text-sm text-white/50">ყველა პროდუქტზე ოფიციალური გარანტია</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}